import 'react-tooltip/dist/react-tooltip.css';

import { forwardRef, useImperativeHandle, useRef } from 'react';
import {
  type PlacesType,
  Tooltip as ReactTooltip,
  TooltipRefProps,
} from 'react-tooltip';

interface TooltipProps {
  content: string;
  anchor: string;
  placement?: PlacesType;
}

export interface TooltipHandle {
  close: () => void;
  closeWithDelay: (delay?: number) => void;
}

const Tooltip = forwardRef<TooltipHandle, TooltipProps>(
  ({ content, anchor, placement = 'top' }, ref) => {
    const tooltipRef = useRef<TooltipRefProps | null>(null);

    useImperativeHandle(ref, () => ({
      close: () => {
        tooltipRef.current?.close?.();
      },
      closeWithDelay: (delay = 200) => {
        setTimeout(() => {
          tooltipRef.current?.close?.();
        }, delay);
      },
    }));

    return (
      <ReactTooltip
        ref={tooltipRef}
        anchorSelect={anchor}
        place={placement}
        className="leading-[150%] !rounded-md !px-3 !py-1 !text-sm font-medium shadow-sm z-10 whitespace-nowrap !bg-white !text-black absolute">
        {content}
      </ReactTooltip>
    );
  },
);

export { Tooltip };
